import * as React from "react";
import { TooltipApi } from "sb-resp-ui";

export class LeagueIcon extends React.PureComponent<{
    className: string,
    tooltip?: string

}, {}>{
    tooltip: {
        "data-tooltip-message": string
    }
    constructor(props) {
        super(props);
        this.tooltip = TooltipApi.getInstance().setMessage(this.props.tooltip)
    }
    render() {
        return (
            <div className={this.props.className} {...this.tooltip} data-uat="div-league-icon">
                {this.props.children}
            </div>
        )
    }
}